<template>
    <!-- <div id="carousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="false"> -->
    <div id="carousel" class="carousel slide" data-bs-ride="carousel">
		<ol class="carousel-indicators">
            <template v-for="(item, index) in items" :key="index">
                <li data-bs-target="#carousel" :data-bs-slide-to="index" :class="index == 0 ? 'active' : ''" aria-current="true" aria-label="Slide 1"></li>
            </template>
		</ol>
		<div class="carousel-inner">

            <template v-for="(item, index) in items" :key="index">
                <div class="carousel-item" :class="index == 0 ? 'active' : '' ">
                    <div class="overlay"></div>
                    <div class="carousel-bg" :style="`background-image: url('${item.image}');`"></div>
                    <div class="carousel-caption d-md-block">
                        <h2>{{ item.title }}</h2>
                        <!-- <h2>{{item.date}}</h2> -->
                        <p>{{ item.subtitle }}</p>
                    </div>
                </div>
            </template>

		</div>

        <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carousel"
            data-bs-slide="prev"
        >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carousel"
            data-bs-slide="next"
        >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>

	</div>
</template>


<script>
export default {
    name: "CarouselC",
    props:['items'],
    setup() {

    },
}
</script>


<style lang="scss">
</style>